export enum TransferType {
  OPTIMIZATION = 'TransferSet::Optimization',
  DEPOSIT = 'TransferSet::Deposit',
  WITHDRAWAL = 'TransferSet::Withdrawal',
  CHECKING_DEPOSIT = 'Checking::Deposit',
  CHECKING_WITHDRAWAL = 'Checking::Withdrawal',
}
